export const styles = {
  container: {
    width: '100%',
    height: '100%',
  },
  imageUploadBox: {
    width: '100%',
    height: '100%',
    marginTop: '24px',
  },
};
